__turbopack_context__.v({
  "Cont": "ProjectList-module-sass-module__BH60dW__Cont",
  "Intro": "ProjectList-module-sass-module__BH60dW__Intro",
  "ProjectList": "ProjectList-module-sass-module__BH60dW__ProjectList",
});
